var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaintenance = function SvgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.74 15.5-7.906-7.907a5.594 5.594 0 0 0-1.253-5.962C7.853-.097 5.261-.443 3.186.551l3.76 3.759L4.31 6.945.55 3.186C-.442 5.26-.096 7.853 1.63 9.581a5.594 5.594 0 0 0 5.963 1.253l7.907 7.907c.346.345.908.345 1.21 0l2.03-2.031c.346-.302.346-.864 0-1.21z",
    fill: "#003B5C"
  })));
};
export default SvgMaintenance;